// Card catalog helpers: image paths, legacy id migration, special-id ranges.

export const BASE_CORGI_COUNT = 500;
export const SPECIAL_CORGI_ID_START = 10000;

/** Old founder/gem ids (1001–1013) → new 10001–10013. */
export const LEGACY_SPECIAL_ID_MAP = Object.freeze({
    1001: 10001,
    1002: 10002,
    1003: 10003,
    1004: 10004,
    1005: 10005,
    1006: 10006,
    1007: 10007,
    1008: 10008,
    1009: 10009,
    1010: 10010,
    1011: 10011,
    1012: 10012,
    1013: 10013,
});

export function normalizeCardId(id) {
    const n = Number(id);
    return Number.isFinite(n) ? n : id;
}

export function isSpecialCorgiId(id) {
    const n = normalizeCardId(id);
    return Number.isFinite(n) && n >= SPECIAL_CORGI_ID_START;
}

export function migrateLegacySpecialId(id) {
    const normalized = normalizeCardId(id);
    if (!Number.isFinite(normalized)) {
        return normalized;
    }
    return LEGACY_SPECIAL_ID_MAP[normalized] ?? normalized;
}

export function migrateCollectionIds(ids = []) {
    const seen = new Set();
    const migrated = [];

    (Array.isArray(ids) ? ids : []).forEach((raw) => {
        const next = migrateLegacySpecialId(raw);
        const key = String(next);
        if (!seen.has(key)) {
            seen.add(key);
            migrated.push(next);
        }
    });

    return migrated;
}

/** Count unlocked ids that exist in the card catalog (ignores stale extras). */
export function countUnlockedCatalogCards(
    unlockedIds = [],
    catalog = null
) {
    const cards = Array.isArray(catalog) ? catalog : [];
    const unlocked = new Set(migrateCollectionIds(unlockedIds).map(normalizeCardId));

    return cards.reduce((acc, card) => {
        return acc + (unlocked.has(normalizeCardId(card.id)) ? 1 : 0);
    }, 0);
}

/**
 * Zero-padded PNG path for base corgis (#1–500).
 */
export function getBaseCorgiImagePath(id) {
    const n = Number(id);
    if (!Number.isFinite(n) || n < 1 || n > BASE_CORGI_COUNT) {
        return "";
    }

    const padded = String(n).padStart(4, "0");
    if (n <= 100) {
        return `../images/1-100/${padded}.png`;
    }
    if (n <= 200) {
        return `../images/101-200/${padded}.png`;
    }
    if (n <= 300) {
        return `../images/201-300/${padded}.png`;
    }
    if (n <= 400) {
        return `../images/301-400/${padded}.png`;
    }
    return `../images/401-500/${padded}.png`;
}
